import styled from 'styled-components';

import { StyleColor } from '../../utils/styles-constants';
import { hexToRgba } from '../../utils/style';

interface ButtonProps {
	isActive: boolean;
	width?: string;
}

const Wrapper = styled('div')`
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 0 0 50px;
`;

const ButtonsWrapper = styled('div')`
	padding: 3px;
	border-radius: 10px;
	background-color: ${StyleColor.Grey50};
`;

const Button = styled('button')`
	min-width: ${(props: ButtonProps) => props.width ? props.width : '150px'};
	padding: 5px;
	border: 0;
	outline: 0;
	background-color: ${StyleColor.Grey50};
	border-radius: inherit;
	font-family: HelveticaNeue, sans-serif;
	font-size: 14px;
	line-height: 20px;
	color: ${StyleColor.Black};
	cursor: pointer;

	&:last-child {
		margin-left: 2px;
	}

	${(props: ButtonProps) => props.isActive && `
		background-color: ${StyleColor.White};
		box-shadow: 0 0 2px 0 ${hexToRgba(StyleColor.Black, 25)};
	`}
`;

export {
	Wrapper,
	ButtonsWrapper,
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Toggle/styles.ts